import Vue from 'vue'
import VueRouter from 'vue-router'
import App from "@/App";
import store from "@/store";

Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        redirect: '/profile',
    },
    {
        path: '',
        name: 'App',
        component: App,
        meta: {title: 'بررسی بورس'},
        children: [
            {
                path: '',
                name: 'Base',
                component: () => import('@/views/Base.vue'),
                children: [
                    {
                        path: 'profile',
                        name: '',
                        component: () => import('@/views/DashboardBase.vue'),
                        children: [
                            {
                                path: '',
                                name: 'Profile',
                                component: () => import('@/components/auth/Profile.vue'),
                            },
                            {
                                path: 'invitations',
                                name: 'Invitations',
                                component: () => import('@/components/dashboard/Invitations.vue'),
                            },
                            {
                                path: 'support',
                                name: 'Support',
                                component: () => import('@/components/dashboard/Support.vue'),
                            },
                        ]
                    },
                    {
                        path: 'reports',
                        name: '',
                        component: () => import('@/views/DashboardBase.vue'),
                        children: [
                            {
                                path: '',
                                name: 'Reports',
                                component: () => import('@/components/dashboard/Reports.vue'),
                            }, {
                                path: 'portfolio',
                                name: 'Portfolio',
                                component: () => import('@/components/dashboard/Portfolio.vue'),
                            },
                            {
                                path: 'orders',
                                name: 'Orders',
                                component: () => import('@/components/dashboard/Orders.vue'),
                            },
                        ]
                    },
                    {
                        name: 'SymbolSearch',
                        path: 'symbol_search',
                        component: () => import('@/components/SymbolSearch.vue')
                    },
                    {
                        name: 'Trade',
                        path: 'trade/:id',
                        component: () => import('@/components/Trade.vue')
                    },
                    {
                        name: 'ContactUs',
                        path: 'contact-us/',
                        component: () => import('@/components/ContactUs.vue')
                    },
                    {
                        name: 'NewsList',
                        path: 'news',
                        component: () => import('@/components/news/NewsList.vue')
                    },
                    {
                        name: 'NewsPost',
                        path: 'news/post',
                        component: () => import('@/components/news/NewsPost.vue')
                    }
                ]
            },
            {
                path: 'auth',
                component: () => import('@/views/AuthBase.vue'),
                name: 'Auth',
                meta: {title: 'بررسی بورس'},

                children: [
                     {
                        path: 'contactus/',
                        name: "GeneralContactUs",
                        meta: {title: 'درباره ما', auth: false},
                        component: () => import('@/components/auth/GeneralContactUs')
                    },
                    {
                        path: 'delete-team-success',
                        name: "DeleteTeamSuccess",
                        meta: {title: 'موفقیت در حذف تیم', auth: false},
                        component: () => import('@/components/common/DeleteTeamVerificationSuccess')
                    },
                    {
                        path: 'delete-team-error',
                        name: "DeleteTeamError",
                        meta: {title: 'مشکل در حذف تیم', auth: false},
                        component: () => import('@/components/common/DeleteTeamVerificationError')
                    },
                    {
                        path: 'email-verification-success',
                        name: "EmailVerificationSuccess",
                        meta: {title: 'تایید ایمیل', auth: false},
                        component: () => import('@/components/common/EmailVerificationSuccess')
                    },
                    {
                        path: 'email-verification-error',
                        name: "EmailVerificationError",
                        meta: {title: 'مشکل در تاییدایمل', auth: false},
                        component: () => import('@/components/common/EmailVerificationError')
                    },
                    {
                        path: 'login',
                        name: "Login",
                        meta: {title: 'ورود', auth: false},
                        component: () => import('@/components/auth/Login.vue')
                    },
                    {
                        path: 'register',
                        name: "Register",
                        meta: {title: 'ثبت نام', auth: false},
                        component: () => import('@/components/auth/Register.vue')
                    },
                    {
                        path: 'forget_password',
                        name: "ForgetPassword",
                        meta: {title: 'بازیابی رمز عبور', auth: false},
                        component: () => import('@/components/auth/ForgetPassword.vue')
                    },

                ]
            },
        ]

    }
]

const router = new VueRouter({
    routes,
    mode: 'history',
    base: ''
})
const nonAuthenticationRequiredRoutes = [
  'GeneralContactUs',
  'Register',
  'ForgetPassword',
  'EmailVerificationError',
  'EmailVerificationSuccess',
  'DeleteTeamError',
  'DeleteTeamSuccess',
];
router.afterEach((to, from) => {
    store.dispatch('get_profile').then(r => {
    }).catch((err) => {
        if (err.response.status === 401) {
            if (to.name !== 'Login' && !nonAuthenticationRequiredRoutes.includes(to.name))
                router.push({name: 'Login'})
        }
    })


})
router.beforeEach((to, from, next) => {
  if (to.path === from.path) {
      console.log('ay babab')
    next(false);
  } else {
    next();
  }
});
router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.name) {
        // Start the route progress bar.
        NProgress.start()
    }
    next()
})

router.afterEach((to, from) => {
    // Complete the animation of the route progress bar.
    NProgress.done()
})

export default router
